import fetchHandler from "../../utils/fetchHandler";
import { MY_WORKOUT } from "../types/actions";

export const getMyWorkouts = () => {
	const fetchOptions = {
		url: `/api/member_exercise_plans`,
		method: "GET",
		actionType: MY_WORKOUT.GET_MY_WORKOUT
	};
	return fetchHandler(fetchOptions);
};

export const deleteMyWorkouts = (successHandler) => {
	const fetchOptions = {
		url: `/api/manage_my_workout`,
		method: "DELETE",
		actionType: MY_WORKOUT.DELETE_MY_WORKOUTS
	};
	return fetchHandler(fetchOptions, successHandler);
};
